import Blacklist from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    blacklists: [],
    filteredCollection: [],
    currentBlacklist: new Blacklist(),
  },
  getters: {
    getBlacklistCollection: state => state.blacklists,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.blacklists.find(blacklist => blacklist.id === id),
    getCurrentBlacklist: state => state.currentBlacklist,
  },
  actions: {
    getBlacklistCollection({ commit, getters }, payload) {
      return this.dispatch('get', {
        path: 'v1/blacklists',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((blacklist) => {
            commit('addBlacklistToCollection', { blacklistData: blacklist })
            return getters.getById(blacklist.id)
          })

          commit('addBlacklistToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/blacklists',
        data: model.getJSON()
      }).then((res) => {

        commit('addBlacklistToCollection', { blacklistData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    updateBlacklist({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/blacklists/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addBlacklistToCollection', { blacklistData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    deleteBlacklist({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/blacklists/' + id
      }).then((res) => {

        commit('removeBlacklistFromCollection', id)

        return res
      })
    },
  },
  mutations: {
    addBlacklistToCollection(state, { blacklistData, opts }) {
      addToCollection(this, state.blacklists, blacklistData, Blacklist, opts)
    },
    addBlacklistToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeBlacklistFromCollection(state, blacklistId) {
      const index = state.blacklists.findIndex(el => el.id === blacklistId)

      if (index === -1) {
        console.warn(`Could not find/delete blacklist ${blacklistId}`)
        return
      }

      state.blacklists.splice(index, 1)
    },
    clearCollection(state) {
      state.blacklists = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    setCurrentBlacklist(state, blacklist) {
      state.currentBlacklist = blacklist
    },
    resetCurrentBlacklist(state) {
      state.currentBlacklist = new Blacklist()
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/blacklist/store.js